import { useEffect } from 'react'
import { useMapStore } from '../../store/mapStore'

// Highlight the multi-selection set (Shift/Ctrl+click) with a tint + outline.
// Layers are created once on the regions source, then only their filter changes.
export function useMultiSelect(map, regionsData) {
  const selectedRegionIds = useMapStore((s) => s.selectedRegionIds)

  useEffect(() => {
    if (!map.current || !map.current.getLayer('regions-fill')) return
    const ids = selectedRegionIds || []

    if (!map.current.getLayer('regions-multiselect-fill')) {
      map.current.addLayer({
        id: 'regions-multiselect-fill',
        type: 'fill',
        source: 'regions',
        layout: { visibility: 'none' },
        paint: { 'fill-color': '#4FD0E0', 'fill-opacity': 0.35 },
      }, 'regions-hover')
      map.current.addLayer({
        id: 'regions-multiselect-line',
        type: 'line',
        source: 'regions',
        layout: { visibility: 'none' },
        paint: { 'line-color': '#4FD0E0', 'line-width': 2 },
      }, 'regions-hover')
    }
    const filter = ['in', ['get', 'region_id'], ['literal', ids]]
    const vis = ids.length ? 'visible' : 'none'
    for (const id of ['regions-multiselect-fill', 'regions-multiselect-line']) {
      map.current.setFilter(id, filter)
      map.current.setLayoutProperty(id, 'visibility', vis)
    }
  }, [map, selectedRegionIds, regionsData])
}
